import React from 'react';
import './ndoeUi.css';
import { NdoeEmpty, NdoeLoading, NdoeError } from './NdoeStates';

/**
 * NdoeMobileList — rend une liste de cartes à partir des données.
 * Gère loading / error / empty de façon uniforme.
 *
 * Props :
 *  - data       : tableau d'items
 *  - renderCard : (item, index) => node (typiquement une <NdoeDataCard/>)
 *  - rowKey     : (item, index) => key (défaut item.id ?? index)
 *  - loading    : bool
 *  - error      : bool | message
 *  - onRetry    : callback pour l'état erreur
 *  - empty      : { icon, title, text, action } pour l'état vide
 *  - className
 */
export default function NdoeMobileList({
  data = [],
  renderCard,
  rowKey,
  loading = false,
  error = false,
  onRetry,
  empty = {},
  className = '',
}) {
  if (loading) return <NdoeLoading rows={empty.rows || 4} />;
  if (error) {
    return (
      <NdoeError
        text={typeof error === 'string' ? error : undefined}
        onRetry={onRetry}
      />
    );
  }
  if (!data || data.length === 0) {
    return <NdoeEmpty icon={empty.icon} title={empty.title} text={empty.text} action={empty.action} />;
  }

  const keyOf = (item, i) => (rowKey ? rowKey(item, i) : item?.id ?? i);

  return (
    <div className={`ndoe-mobile-list ${className}`}>
      {data.map((item, i) => (
        <React.Fragment key={keyOf(item, i)}>{renderCard(item, i)}</React.Fragment>
      ))}
    </div>
  );
}
